import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { jsx as _jsx } from "react/jsx-runtime";
export const Timestamp = ({
  timestamp
}) => {
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "top",
    title: /*#__PURE__*/_jsx(FormattedDateTime, {
      value: timestamp,
      format: "LLLL",
      type: "userTz"
    }),
    children: /*#__PURE__*/_jsx(FormattedDateTime, {
      value: timestamp,
      format: "LT",
      type: "userTz"
    })
  });
};